import NotLoggedInContainer from '../base/NotLoggedInContainer'
import { styled, Typography } from '@mui/material'
import Lottie from 'react-lottie-player'

const Container = styled('div')({
  padding: '64px 24px',
  maxWidth: '500px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  rowGap: '16px',
  margin: 'auto'
})

const LottieContainer = styled('div')({
  width: '50%',
  aspectRatio: '1',
  position: 'relative',
})


const ConfirmYourEmail = ({ title, body }) => {
  return (
    <NotLoggedInContainer student={true} type={'sign-up'}>
      <Container>
        <Typography variant={'h3'} sx={{ textAlign: 'center' }}>
          {title}
        </Typography>
        <Typography variant={'body1'} sx={{ textAlign: 'center' }}>
          {body}
        </Typography>
        <LottieContainer>
          <Lottie
            animationData={require('public/static/lottie/EmailConfirmation.json')}
            play
            loop={false}
          />
        </LottieContainer>
      </Container>
    </NotLoggedInContainer>
  )
}

export default ConfirmYourEmail
